<template>
  <span>
    <template v-if="categoryName">
      <template v-if="isGlamping">
        <translate
          v-if="place && !distance"
          :tt="{
            count: bookableCount,
            categoryName: formattedCategoryName,
            place,
          }"
          >{count} bookable {categoryName} in {place}</translate
        >
        <translate
          v-else-if="place && distance"
          :tt="{
            count: bookableCount,
            categoryName: formattedCategoryName,
            distance,
            place,
          }"
          >{count} bookable {categoryName} within {distance} of
          {place}</translate
        >
        <translate
          v-else-if="!place && distance && isUserLocationSearch"
          :tt="{
            count: bookableCount,
            categoryName: formattedCategoryName,
            distance,
          }"
          >{count} bookable {categoryName} within {distance} of your
          location</translate
        >
        <translate
          v-else
          :tt="{ count: bookableCount, categoryName: formattedCategoryName }"
          >{count} bookable {categoryName}</translate
        >
      </template>
      <translate
        v-else-if="searchPlace && distance"
        :tt="{
          count: bookableCount,
          categoryName: formattedCategoryName,
          distance,
          searchPlace,
        }"
        >{count} bookable campsite with {categoryName} within {distance} of
        {searchPlace}</translate
      >
      <translate
        v-else-if="distance && isUserLocationSearch"
        :tt="{
          count: bookableCount,
          categoryName: formattedCategoryName,
          distance,
          isUserLocationSearch,
        }"
        >{count} bookable campsite with {categoryName} within {distance} of your
        location</translate
      >
      <translate
        v-else-if="hierarchyName"
        :tt="{
          count: bookableCount,
          categoryName: formattedCategoryName,
          hierarchyName,
        }"
        >{count} bookable campsite with {categoryName} in
        {hierarchyName}</translate
      >
      <translate
        v-else
        :tt="{ count: bookableCount, categoryName: formattedCategoryName }"
        >{count} bookable campsite with {categoryName}</translate
      >
    </template>
    <template v-else>
      <translate
        v-if="searchPlace && distance"
        :tt="{ count: bookableCount, distance, searchPlace }"
        >{count} bookable campsite within {distance} of {searchPlace}</translate
      >
      <translate
        v-else-if="distance && isUserLocationSearch"
        :tt="{ count: bookableCount, distance }"
        >{count} bookable campsite within {distance} of your location</translate
      >
      <translate
        v-else-if="hierarchyName"
        :tt="{ count: bookableCount, hierarchyName }"
        >{count} bookable campsite in {hierarchyName}</translate
      >
      <translate v-else :tt="{ count: bookableCount }"
        >{count} bookable campsite</translate
      >
    </template>
  </span>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { isGlamping } from '~/utility/glamping'

@Component
class SearchSummaryBookableCountSearch extends Vue {
  @Prop()
  bookableCount: number

  @Prop()
  categoryIds?: string[]

  @Prop()
  distance: object

  @Prop()
  searchPlace: string

  @Prop()
  hierarchyName: string

  @Prop()
  categoryName?: string

  @Prop()
  isUserLocationSearch: boolean

  get isGlamping() {
    return isGlamping(this.categoryIds)
  }

  get formattedCategoryName() {
    return this.categoryName && this.categoryName.toLowerCase()
  }

  get place() {
    return this.hierarchyName || this.searchPlace
  }
}

export default toNative(SearchSummaryBookableCountSearch)
</script>
